
import Copy from "csi/table/Copy";
import comm from "csi/comm";
import xml from "csi/xml";
import { CallMethod } from "csi/xml/CallMethod";
import declare from "dojo/_base/declare";
import _ from "lodash";
import MultiActionPopupMixin from "csi/action/MultiActionPopupMixin";
import Writer from "csi/xml/Writer";

/* Fields */
const PROJECT = "Project";
const SKU_BOMS = "SKUBOMs";
const SKU_FOOD_BOM = "SKUFoodBOM";

const CopyFoodSKUController = declare([Copy, MultiActionPopupMixin], {
	// Dialog localization strings
	loadingMessageTemplateSingular: "MultiCopyFoodSKU_LoadingSingular",
	loadingMessageTemplatePlural: "MultiCopyFoodSKU_LoadingPlural",
	successMessageTemplateSingular: "MultiCopyFoodSKU_SuccessSingular",
	successMessageTemplatePlural: "MultiCopyFoodSKU_SuccessPlural",

	// String: name of field containing number of nodes to create
	numCreateField: "CopyCount",

	/**
	 * @override
	 * Control multicopy behavior for FoodSKU
	 */
	toWriterRequest(): CallMethod {
		const call = this.inherited<CallMethod>(arguments);

		const fd = this.m_formData;
		call.addParameter("CopyCount", xml.ATTR_INTEGER, fd.getFieldValue("CopyCount", true));
		call.addParameter("FromSKU", xml.ATTR_REF, this.m_nodeSource.$URL);
		call.addParameter("Node Name", xml.ATTR_STRING, fd.getFieldValue("Node Name", true));
		call.addParameter("SKURecipe", xml.ATTR_REF, fd.getFieldValue("SKURecipe", true));
		call.addParameter("SKUArtworks", xml.ATTR_REFLIST, fd.getFieldValue("SKUArtworks", true));
		call.addParameter("SKUFoodLabel", xml.ATTR_REF, fd.getFieldValue("SKUFoodLabel", true));
		call.addParameter("SKULabelDataSheets", xml.ATTR_REFSET, fd.getFieldValue("SKULabelDataSheets", true));
		call.addParameter("SKUFoodBOM", xml.ATTR_REF, fd.getFieldValue("SKUFoodBOM", true));
		call.addParameter("SKUBOMs", xml.ATTR_REFSET, fd.getFieldValue("SKUBOMs", true));
		call.addParameter("SKUSpecs", xml.ATTR_REFLIST, fd.getFieldValue("SKUSpecs", true));
		call.addParameter("SKURecipes", xml.ATTR_REFLIST, fd.getFieldValue("SKURecipes", true));
		call.addParameter("SKUTestRuns", xml.ATTR_REFLIST, fd.getFieldValue("SKUTestRuns", true));
		call.addParameter("FPSProductSalesRegion", xml.ATTR_REF, fd.getFieldValue("FPSProductSalesRegion", true));
		call.addParameter(PROJECT, xml.ATTR_REF, fd.getFieldValue(fd.getFieldById(PROJECT), true));

		_.forEach(fd.getFields(), (field) => {
			const fieldId = field.idParameter || field.m_id;
			if (fieldId && !field.m_bUsed) {
				call.addGeneralizedParameter(fieldId, field.getType(), field.getValue());
				field.m_bUsed = true;
			}
		});

		return call;
	},

	/**
	 * @override
	 * Overridden to prevent ValidateAndDeleteIfFailed call on frontend, validation is handled in java operation
	 */
	_toWriterValidateNode() {
		const w: Writer = this.m_writer;

		w.flushChanges();
	},


});

export = CopyFoodSKUController;
